<template>
    <mc-tooltip
        content="务必注意，如果过期未更新，可能有停采风险！！"
        placement="top"
        theme="light"
    >
        <span
            v-if="expirationText[status]"
            class="expiration-badge"
            :style="{ color: expirationBorderColor[status] }"
        >{{ expirationText[status] }}</span>
    </mc-tooltip>
</template>

<script>
import { expirationText, expirationBorderColor } from './constants';

export default {
    name: 'ExpirationBadge',
    props: {
        status: {
            type: [String, Number],
            default: 0,
        },
    },
    data() {
        return {
            expirationText,
            expirationBorderColor,
        };
    },
};
</script>

<style scoped>
.expiration-badge {
    display: inline-block;
    position: relative;
    padding: 2px 2px;
    border: 1px dashed;
    border-radius: 2px;
    font-weight: bold;
    transform: rotate(45deg);
    font-size: 10px;
    line-height: 15px;
}
</style>
